import { HomeOutlined, NavigateNext } from '@mui/icons-material'
import { Box, Breadcrumbs, Link, Skeleton, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useBreadcrumbs } from './BreadcrumbContext'

const breadcrumbsSx = {
  ml: 3,
  flexGrow: 1,
  minWidth: 0,
  overflow: 'hidden',
  '& ol': { flexWrap: 'nowrap', width: '100%' },
  '& li:not([aria-hidden])': { minWidth: 0, overflow: 'hidden' },
  '& li[aria-hidden]': { flexShrink: 0 },
} as const

const HomeCrumb: React.FC = () => (
  <Link
    component={RouterLink}
    to="/dashboard"
    color="text.secondary"
    underline="hover"
    sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}
  >
    <HomeOutlined sx={{ fontSize: 22 }} />
  </Link>
)

const NavBreadcrumbs: React.FC = () => {
  const { crumbs, loading } = useBreadcrumbs()

  if (loading) {
    return (
      <Breadcrumbs separator={<NavigateNext sx={{ fontSize: 20 }} />} aria-label="breadcrumb" sx={breadcrumbsSx}>
        <HomeCrumb />
        <Skeleton variant="text" width={110} />
        <Skeleton variant="text" width={150} />
      </Breadcrumbs>
    )
  }

  if (crumbs.length === 0) return <Box />

  return (
    <Breadcrumbs separator={<NavigateNext sx={{ fontSize: 20 }} />} aria-label="breadcrumb" sx={breadcrumbsSx}>
      <HomeCrumb />
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1
        const key = `${index}-${crumb.label}`
        if (isLast || !crumb.to) {
          return (
            <Typography key={key} color="text.secondary" noWrap sx={{ minWidth: 0 }}>
              {crumb.label}
            </Typography>
          )
        }
        return (
          <Link
            key={key}
            component={RouterLink}
            to={crumb.to}
            variant="body1"
            color="text.secondary"
            underline="hover"
            noWrap
            sx={{ minWidth: 0 }}
          >
            {crumb.label}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}

export default NavBreadcrumbs
